"use client"

export const Button = ({ children, onClick, className = "", ...props }) => (
  <button
    onClick={onClick}
    className={`py-2 px-4 rounded-lg font-medium transition-all duration-200 text-white ${className}`}
    {...props}
  >
    {children}
  </button>
)
